<!-- 扩展页面 -->
<template>
  <div class="expand">
    <el-dialog
      :title="$t('supplyChain.dialog.extend')"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
      :before-close="handleClose"
    >
      <vxe-grid
        border
        show-overflow
        resizable
        ref="expandtable"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :data="tableData"
        :edit-config="{ trigger: 'click', mode: 'row' }"
      >
        <vxe-table-column type="index" width="50"></vxe-table-column>
        <vxe-table-column
          field="supplierName"
          :title="$t('supplyChain.label.supplierName')"
        ></vxe-table-column>
        <!-- 选择扩展部门 -->
        <vxe-table-column
          field="extendRequestDepartment"
          :title="$t('cooperation.label.extendRequestDepartment')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <el-select
              clearable
              filterable
              multiple
              value-key="personDepartmentCode"
              @change="selectDepartment"
              v-model="scope.row.extendRequestDepartment"
              :placeholder="$t('cooperation.placeholder.extendRequestDepartment')"
            >
              <el-checkbox v-model="checked" @change="selectAll(scope)">全选</el-checkbox>
              <el-option
                v-for="item in extendRequestDepartmentList"
                :key="item.personDepartmentCode"
                :label="item.personDepartmentName"
                :value="item"
              ></el-option>
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="extendRequestPersonName"
          :title="$t('cooperation.label.requestBy')"
        ></vxe-table-column>
      </vxe-grid>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('supplyChain.button.cancel') }}</el-button>
        <el-button type="primary" @click="save">{{ $t('supplyChain.button.sure') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/masterData/supplyChain.js';
  import { mapState } from 'vuex';
  // import { dateTimeFormat } from '@/filters'; // 导入时间格式化方法
  export default {
    name: 'expand',
    components: {
      // SiruiTable,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    props: ['extendRequestDepartmentList'],
    data() {
      return {
        departmentList: [], //所选部门列表
        companyInfo: {},
        checked: false,
        dialogVisible: false,
        load: false,
        tableData: [],
        propData: null, // 存储重复的合作伙伴对象
        repeatData: '', // 重复字段
      };
    },
    methods: {
      // 打开弹窗
      openDialog(data, value, companyInfo) {
        this.tableData = [];
        this.propData = data;
        this.companyInfo = companyInfo;
        const obj = {
          supplierName: this.propData.supplierName,
          departmentName: this.userInfo.departmentName,
          extendRequestPersonName: this.userInfo.userName,
        };
        this.tableData.push(obj);
        this.dialogVisible = true;
      },
      // 获取被扩展对象详情
      save() {
        this.saveMul();
      },
      saveMul() {
        let companyInfo = this.companyInfo;
        console.log(companyInfo);
        const pararms = {
          ...companyInfo,
          supplierCode: this.propData.supplierCode,
          departmentCodes: this.departmentList.map((it) => it.personDepartmentCode),
        };
        this.$refs.expandtable.validate((valid) => {
          if (valid) {
            this.$axios.post(API.SAVE_SUPPLY_EXTEND, pararms).then((res) => {
              if (res.data.code === 0) {
                // this.$emit("getExpandData", data); // 返回扩展数据
                // this.$emit("partnerTypeChange"); // 合作伙伴类型切换
                // this.$emit("changeCountry"); // 获取省份市
                this.dialogVisible = false;
                this.$message({
                  showClose: true,
                  message: '供应链主体扩展成功！',
                  type: 'success',
                });
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            });
          }
        });
      },
      selectDepartment(value) {
        console.log('执行了');
        console.log(value);
        if (value) {
          this.departmentList = value;
          if (value.length === this.extendRequestDepartmentList.length) {
            this.checked = true;
          } else {
            this.checked = false;
          }
        }
      },
      // 全选
      selectAll(scope) {
        console.log(this.checked);
        // console.log(scope.row.extendRequestDepartment);
        this.departmentList = [];
        if (this.checked) {
          this.extendRequestDepartmentList.map((item) => {
            this.departmentList.push(item);
            scope.row.extendRequestDepartment.push(item);
          });
          console.log(this.departmentList);
        } else {
          this.departmentList = [];
          scope.row.extendRequestDepartment = [];
        }
      },
      // 关闭弹窗
      handleClose() {
        this.dialogVisible = false;
        // this.$emit('deleteSupplierName');
      },
    },
  };
</script>

<style>
  .expand .vxe-toolbar {
    display: none;
  }
</style>
